<script>
    /*
    	CancelButton.svelte
    */

    import { pop } from 'svelte-spa-router';

    // TCARE components

    // SMUI components

</script>

<style>

    /* TODO: use a SMUI Button here? */
    .cancel-button button {
        width: 125px;
        height: 35px;
        margin: 0px;
        font-size: 14px;
        line-height: 16px;
        letter-spacing: 1px;
        color: var(--tcui-primary);
        background-color: white;
        border-radius: 16px;
        border: 1px solid #E9E5EA;
    }

    .cancel-button button:hover {
        background-color: var(--tcui-aqua);
    }

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="cancel-button">
    <button on:click={() => pop()}>
        CANCEL
    </button>
</div>
